export default "__VITE_ASSET__CL9u6b1A__"